import { render, staticRenderFns } from "./ServiceChat.vue?vue&type=template&id=873e7e38"
import script from "./ServiceChat.vue?vue&type=script&lang=js"
export * from "./ServiceChat.vue?vue&type=script&lang=js"
import style0 from "./ServiceChat.vue?vue&type=style&index=0&id=873e7e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports